import { RawWeaponPresentation } from '../types/api/drill';
import { WeaponPresentation } from '../types/ui/weaponPresentation';

export function toWeaponPresentation(
  raw: RawWeaponPresentation
): WeaponPresentation {
  return {
    metrics: raw.metrics
      ? {
          reactionTime:       raw.metrics.reaction_time,
          motionTime:         raw.metrics.motion_time,
          linearityError:     raw.metrics.linearity_error,
          motionDistance:     raw.metrics.motion_distance,
          movementType:       raw.metrics.movement_type,
          earlyPresentation:  raw.metrics.early_presentation,
          potentialSavedTime: raw.metrics.potential_saved_time,
        }
      : null,

    eventsInfo: raw.events_info
      ? {
          firstShotStart:        raw.events_info.first_shot_start,
          buzzerStart:           raw.events_info.buzzer_start,
          presentationStartTime: raw.events_info.presentation_start_time,
          presentationEndTime:   raw.events_info.presentation_end_time,
          presentationHeadX:     raw.events_info.presentation_head_x,
          presentationHeadY:     raw.events_info.presentation_head_y,
        }
      : null,

    sideView: Array.isArray(raw.side_view)
      ? raw.side_view.map(p => ({
          x: p.position_x,
          y: p.position_y,
        }))
      : [],

    heightTime: Array.isArray(raw.height_time)
      ? raw.height_time.map(h => ({
          time: h.time,
          y:    h.position_y,
        }))
      : [],
  };
}
